(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (reducedMotion.matches || !Element.prototype.animate) return;

  const start = () => {
    const isMobile = window.matchMedia('(max-width: 749px)').matches;
    const hero = document.querySelector('[id$="__media_with_content_RVymQU"]');
    const heroImage = hero?.querySelector('.media-block__media');
    const heroContent = hero?.querySelector('.media-with-content__content');

    if (heroImage) {
      const mediaFrame = heroImage.closest('.media-block');
      if (mediaFrame) mediaFrame.style.overflow = 'clip';
      heroImage.style.transformOrigin = isMobile ? '52% 50%' : '50% 50%';
      heroImage.style.willChange = 'transform';

      const heroFrames = isMobile
        ? [
            { transform: 'scale(1.012) translate3d(0, 0, 0)' },
            { transform: 'scale(1.028) translate3d(-0.25%, -0.15%, 0)' }
          ]
        : [
            { transform: 'scale(1.012) translate3d(0.25%, 0.15%, 0)' },
            { transform: 'scale(1.055) translate3d(-0.65%, -0.35%, 0)' }
          ];

      heroImage.animate(heroFrames, {
        duration: isMobile ? 18000 : 24000,
        direction: 'alternate',
        easing: 'ease-in-out',
        fill: 'both',
        iterations: Infinity
      });
    }

    if (heroContent) {
      const introItems = heroContent.querySelectorAll(
        '.text-block, rte-formatter, .group-block--width-fit-content'
      );
      introItems.forEach((item, index) => {
        item.animate(
          [
            { opacity: 0, transform: 'translate3d(0, 12px, 0)' },
            { opacity: 1, transform: 'translate3d(0, 0, 0)' }
          ],
          {
            duration: 760,
            delay: 120 + (index * 90),
            easing: 'cubic-bezier(.22,.7,.25,1)',
            fill: 'both'
          }
        );
      });
    }

    const observed = new Set();
    const reveal = (element, direction = 'up', delay = 0) => {
      if (observed.has(element)) return;
      observed.add(element);
      const x = direction === 'left' ? 12 : direction === 'right' ? -12 : 0;
      const y = direction === 'up' ? 14 : 0;
      element.animate(
        [
          { opacity: 0.01, transform: `translate3d(${x}px, ${y}px, 0) scale(.985)` },
          { opacity: 1, transform: 'translate3d(0, 0, 0) scale(1)' }
        ],
        {
          duration: isMobile ? 620 : 820,
          delay,
          easing: 'cubic-bezier(.22,.7,.25,1)',
          fill: 'both'
        }
      );
    };

    const fourPathFrames = document.querySelectorAll(
      '[id$="__1780199917f0f509a7"] [class*="ai-pathway__image-wrap-"]'
    );
    const miracleImages = document.querySelectorAll(
      '[id$="__blocks_3FiqWd"] img[class*="ai-editorial-bestseller-image-"]'
    );
    const targets = [...fourPathFrames, ...miracleImages];

    if (!('IntersectionObserver' in window)) {
      targets.forEach((target, index) => reveal(target, 'up', Math.min(index * 60, 180)));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const target = entry.target;
          const pathIndex = [...fourPathFrames].indexOf(target);
          const miracleIndex = [...miracleImages].indexOf(target);
          const direction = miracleIndex === 0 ? 'left' : miracleIndex === 1 ? 'right' : 'up';
          const delay = pathIndex >= 0 ? Math.min(pathIndex * 70, 210) : Math.max(miracleIndex, 0) * 90;
          reveal(target, direction, delay);
          observer.unobserve(target);
        });
      },
      { rootMargin: '0px 0px 14% 0px', threshold: 0.08 }
    );

    targets.forEach((target) => observer.observe(target));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
